<template>
  <div>
    <section class="content">
      <div class="col-md-12" style="padding: 0;">
        <!--        <div class="portlet light">-->
        <!--          <div class="portlet-title">-->
        <!--            <div class="caption pull-left">-->
        <!--              <div class="subject">-->
        <!--                <span class="caption-subject">Les membres affiliés dans votre club</span>-->
        <!--              </div>-->
        <!--              <div class="subsubject">-->
        <!--                Retrouvez la liste des membres affiliés à votre club-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <div class="portlet-body">-->
        <!--            <form method="POST" action="" @submit.prevent="refreshListing()">-->
        <!--              <div class="box-body">-->
        <!--                <div class="row" style="">-->
        <!--                  <div class="col-md-12">-->
        <!--                    <label>Années à afficher :</label>-->
        <!--                    <div class="form-group">-->
        <!--                      <label class="checkbox-inline" v-for="annee in anneesDispo()" style="font-weight: 400;">-->
        <!--                        <input id="anneeToShow" :value="annee" type="checkbox"-->
        <!--                               v-model="show.annees">-->
        <!--                        {{annee}}-->
        <!--                      </label>-->
        <!--                    </div>-->
        <!--                  </div>-->
        <!--                </div>-->
        <!--                <div class="row" style="margin-top: 25px;">-->
        <!--                  <div class="col-md-12">-->
        <!--                    <label>Filtres :</label>-->
        <!--                    <div class="form-group">-->
        <!--                      &lt;!&ndash;                      <label class="checkbox-inline" style="font-weight: 400;">&ndash;&gt;-->
        <!--                      &lt;!&ndash;                        <input id="showDoublons" type="checkbox"&ndash;&gt;-->
        <!--                      &lt;!&ndash;                               v-model="show.showDoublons">&ndash;&gt;-->
        <!--                      &lt;!&ndash;                        Afficher les doublons pour chaque année&ndash;&gt;-->
        <!--                      &lt;!&ndash;                      </label>&ndash;&gt;-->
        <!--                      <label class="checkbox-inline" style="font-weight: 400;" :style="{'color': show.annees.length==1 && show.annees[0]==moment().year() ? '#CCC':'#333'}">-->
        <!--                        <input id="notLicencieCurrentYearOnly" type="checkbox" :disabled="show.annees.length==1 && show.annees[0]==moment().year()"-->
        <!--                               v-model="show.notLicencieCurrentYearOnly">-->
        <!--                        Afficher uniquement les non-licenciés en {{currentYear()}}-->
        <!--                      </label>-->
        <!--                    </div>-->
        <!--                  </div>-->
        <!--                </div>-->
        <!--              </div>-->
        <!--              <div class="box-footer">-->
        <!--                <input type="submit"-->
        <!--                       :disabled="loadingRequest || show.annees.length<=0"-->
        <!--                       value="Rechercher" class="btn btn-primary pull-right"/>-->
        <!--              </div>-->
        <!--            </form>-->
        <!--          </div>-->
        <!--        </div>-->

        <div>

        </div>
        <div class="portlet light">
          <div class="portlet-title">
            <div class="caption pull-left" v-if="!loadingRequest">
              <div class="subject">
                <span class="caption-subject">
                  {{ licencesQueried.length }} membre{{ licencesQueried.length > 0 ? 's' : '' }}
                  ({{ getMembresByStatut().licencied.length }} membre{{ getMembresByStatut().licencied.length > 0 ? 's' : '' }} licencié{{ getMembresByStatut().licencied.length > 0 ? 's' : '' }})
                  <!--                  {{getMembresByStatut().nearNotLicencied.length}} membres en fin de licence /-->
                  <!--                  {{getMembresByStatut().notLicencied.length}} membres non-licenciés-->
                </span>
              </div>
              <div class="subsubject">
                Suite à l'application du RGPD, les membres qui ne sont plus affiliés depuis le {{ dateTwoYearsAgo() }} ne sont plus affichés.
                <br>
                <button class="btn btn-primary btn-xs pull-left"
                        @click.stop="exportListing()">
                  Télécharger le listing des membres
                </button>
              </div>
            </div>
            <div class="caption pull-left" v-if="loadingRequest">
              <div class="subject">
                <span class="caption-subject">Recherche en cours</span>
              </div>
              <div class="subsubject">
                Veuillez patienter
              </div>
            </div>

            <div class="pull-right">
              <b-form-input class="form-control" v-model="filter" placeholder="Rechercher..."></b-form-input>
            </div>


          </div>
          <div class="portlet-body">

            <vue-simple-spinner
              :size="64"
              message="Chargement en cours..."
              :spacing="25"
              text-fg-color="#FFF"
              :font-size="16"
              v-if="loadingRequest"
            ></vue-simple-spinner>
            <div v-if="!loadingRequest">
              <b-table responsive bordered striped hover
                       :items="licencesQueried"
                       :fields="columns"
                       :filter="filter"
                       :per-page="perPage"
                       empty-text="Données indisponibles"
                       :current-page="currentPage"
                       :sort-compare="sortCompareAdvanced"
                       :no-sort-reset="true"
                       :empty-text="'Aucun résultat'"
                       :empty-filtered-text="'Aucun résultat'"
                       show-empty
                       :sort-by.sync="sortBy"
                       :sort-desc.sync="sortDesc"
              >

                <!--                <template v-slot:table-colgroup="scope">-->
                <!--                  <col-->
                <!--                    v-for="field in scope.fields"-->
                <!--                    :key="field.key"-->
                <!--                    :style="{ width: field.key === 'actions' ? '180px' : '120px' }"-->
                <!--                  >-->
                <!--                </template>-->

                <template v-slot:cell(zoom)="row">
                  <button class="btn btn-default btn-xs  pull-left"
                          @click.stop="row.toggleDetails"
                  >
                    <i class="fa"
                       :class="{'fa-search-plus':!row.detailsShowing,'fa-search-minus':row.detailsShowing}"
                    >
                    </i>
                  </button>
                </template>
                <template v-slot:cell(actions)="row">
                  <button class="btn  btn-xs pull-right"
                          :class="{'btn-primary':!isAlreadyInCart(row.item.member.id), 'btn-success':isAlreadyInCart(row.item.member.id)}"
                          @click="addToCartFct(row.item)"
                          :disabled="row.item.member.alreadyInAnOrder  || row.item.member.cantBeSelect || isAlreadyInCart(row.item.member.id)"
                          v-if="(isNearNotLicencied(row.item.date_fin) ||
                          isNotLicencied(row.item.date_fin)) &&
                          getClub.rights.can_register_member">
                    <template v-if="!isAlreadyInCart(row.item.member.id) && !row.item.member.alreadyInAnOrder  && !row.item.member.cantBeSelect">Renouveller</template>
                    <template v-if="isAlreadyInCart(row.item.member.id) &&  !row.item.member.cantBeSelect">Dans votre panier</template>
                    <template v-if=" !isAlreadyInCart(row.item.member.id) && !row.item.member.alreadyInAnOrder  && row.item.member.cantBeSelect ">
                      <div
                        v-b-tooltip.hover
                        :title="'Vous ne pouvez pas renouveller ce membre en ligne. Cette licence nécessite une intervention du secrétariat pour son renouvellement.'"
                        aria-hidden="true">
                        Non-renouvellable
                      </div>
                    </template>

                    <template v-if=" !isAlreadyInCart(row.item.member.id) && row.item.member.alreadyInAnOrder && !row.item.member.cantBeSelect ">
                      <div
                        v-b-tooltip.hover
                        :title="'Vous avez déjà commandé une licence pour ce membre. Si vous souhaitez annuler cette commande, veuillez contacter le secrétariat de la fédération.'"
                        aria-hidden="true">
                        Déjà commandé
                      </div>
                    </template>

                  </button>
                </template>

                <template v-slot:cell(date_fin)="data">
                  <span :class="{
                  'text-danger':isNotLicencied(data.item.date_fin),
                  'text-warning':isNearNotLicencied(data.item.date_fin),
                  'text-green':isLicencied(data.item.date_fin) && !isNearNotLicencied(data.item.date_fin),
                  }">
                    {{ data.item.date_fin }}
                    <i
                      v-if="isNotLicencied(data.item.date_fin) "
                      class="fa fa-exclamation-triangle  text-danger"
                      v-b-tooltip.hover :title="'La licence de ce membre est expirée'"
                      aria-hidden="true">
                    </i>
                    <i
                      v-if="isNearNotLicencied(data.item.date_fin)"
                      class="fa fa-exclamation-triangle text-warning"
                      v-b-tooltip.hover :title="'La licence de ce membre arrive prochainement à expiration'"
                      aria-hidden="true">
                    </i>
                  </span>
                </template>
                <template v-slot:row-details="row">
                  <b-card>
                    <b-row class="mb-2">
                      <b-col sm="3" class="text-sm-right"><b>Numéro de licence:</b></b-col>
                      <b-col>N°{{ row.item.numero_licence | idFormat }}</b-col>
                    </b-row>

                    <b-row class="mb-2">
                      <b-col sm="3" class="text-sm-right"><b>Email:</b></b-col>
                      <b-col>
                        <span v-if="!row.item.mail">-</span>
                        <a v-if="row.item.mail" :href="'mailto:'+row.item.mail">{{ row.item.mail }}</a>
                      </b-col>
                    </b-row>

                    <b-row class="mb-2">
                      <b-col sm="3" class="text-sm-right"><b>Age:</b></b-col>
                      <b-col>{{ row.item.age }} ans</b-col>
                    </b-row>
                    <b-row class="mb-2">
                      <b-col sm="3" class="text-sm-right"><b>Grade:</b></b-col>
                      <b-col>
                        <div v-if="!row.item.can_set_grade">
                          {{ row.item.grade.grade }}
                          <i class="fa fa-info-circle"
                             v-tooltip.top-center="`Ce membre n'est pas licencié ou n'est plus licencié dans votre club, vous ne pouvez donc pas modifier son grade.`">
                          </i>
                        </div>
                        <div v-if="row.item.can_set_grade && idGradeIsDanOrFirstKeup(row.item.grade.id)">
                          {{ row.item.grade.grade }}
                          <i class="fa fa-info-circle"
                             v-tooltip.top-center="`Ce membre a passé un examen fédéral. Vous ne pouvez pas modifier son grade.`">
                          </i>
                        </div>
                        <select
                          class="form-control-override"
                          :disabled="!row.item.can_set_grade"
                          v-if="row.item.can_set_grade && !idGradeIsDanOrFirstKeup(row.item.grade.id)"
                          v-model="row.item.grade.id">
                          <option
                            v-for="grade in getGradesOrdered()"
                            :value="grade.id">
                            {{ grade.grade }}
                          </option>
                        </select>
                      </b-col>
                    </b-row>
                    <b-row class="mb-2" v-if="row.item.prochain_passage">
                      <b-col sm="3" class="text-sm-right"><b>Prochain passage possible:</b></b-col>
                      <b-col>{{ getProchainPassage(row.item.prochain_passage) }}</b-col>
                    </b-row>
                    <b-button
                      :disabled="saveEnCours || !getClub.rights.write || !row.item.can_set_grade ||
                      (row.item.can_set_grade && idGradeIsDanOrFirstKeup(row.item.grade.id))"
                      size="sm" class="pull-right"
                      @click="sendForSave(row.item)">
                      Sauvegarder
                    </b-button>
                  </b-card>
                </template>
              </b-table>
              <div class="row">
                <b-pagination
                  style="margin-top: 0;"
                  size="md" :total-rows="licencesQueried.length" v-model="currentPage"
                  :per-page="perPage"></b-pagination>
                <b-col md="6" class="pull-right my-1">
                  <div style="display:inline-block" class="margin-r-5; pull-right">
                    <span style="display:inline-block">Par Page:</span>
                    <select class="form-control" v-model="perPage"
                            style="display:inline-block;width: 100px;">
                      <option :value="20">20</option>
                      <option :value="50">50</option>
                      <option :value="75">75</option>
                      <option :value="100">100</option>
                      <option :value="999999">Tout</option>
                    </select>
                  </div>
                </b-col>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script type="text/javascript">
import Auth from '@/auth'
import moment from 'moment/moment'
import {mapGetters, mapActions} from 'vuex'
import {getProchainPassage} from "../../utils/utils";
import FileSaver from "file-saver";

var $ = require('jquery')
var _ = require('lodash')

export default {
  data() {
    return {
      licencesQueried: [],
      licencesChecked: [],
      nombreDoublons: 0,
      currentPage: 1,
      perPage: 50,
      gradeSelected: null,
      loadingRequest: false,
      saveEnCours: false,
      filter: '',
      sortBy: 'date_fin',
      sortDesc: true,
      show: {
        notLicencieCurrentYearOnly: false,
        showDoublons: false,
        annees: [moment().year()],
        memberLicencies: true,
        memberNotLicencies: true
      },
      columns: [
        {
          label: 'Détails',
          key: 'zoom',
        },
        {
          label: 'Nom',
          key: 'nom',
          sortable: true,
        },
        {
          label: 'Prénom',
          key: 'prenom',
          sortable: true,
        },
        {
          label: 'Date de naissance',
          key: 'date_naissance',
          // type: 'date',
          // inputFormat: 'DD/MM/YYYY',
          // outputFormat: 'DD/MM/YYYY',
          sortable: true,
        },
        {
          label: 'Date de début de licence',
          key: 'date_debut',
          sortable: true,
          // type: 'date',
          // inputFormat: 'DD/MM/YYYY',
          // outputFormat: 'DD/MM/YYYY',
        },
        {
          label: 'Date de fin de licence',
          key: 'date_fin',
          sortable: true,
          // inputFormat: 'DD/MM/YYYY',
          // outputFormat: 'DD/MM/YYYY',
        },
        {
          label: 'Actions',
          key: 'actions',
        },

      ],
    }
  },
  methods: {
    ...mapActions({
      setGrades: 'setGrades',
      addToCart: 'addToCart'
    }),
    isAlreadyInCart: function (id) {
      return _.has(this.getCart, 'licence_renew')
        && _.has(this.getCart.licence_renew, id)
    },
    addToCartFct: function (item) {
      let product = {
        type: 'licence_renew',
        membre: item.member,
        quantity: 1
      }
      this.addToCart(product)
      this.$noty.success("Ce renouvellement a été ajouté à votre panier")
    },
    sortCompareAdvanced: function (a, b, key) {
      return this.$sortCompareAdvanced(a, b, key)
    },
    isNearNotLicencied: function (date) {
      if (moment(date, 'DD/MM/YYYY').subtract('3', 'months').isBefore(moment())
        && !this.isNotLicencied((date))
      )
        return true
      return false
    },

    isNotLicencied: function (date) {
      if (moment().isAfter(moment(date, 'DD/MM/YYYY')))
        return true
      return false
    },
    isLicencied: function (date) {
      if (moment().isBefore(moment(date, 'DD/MM/YYYY')))
        return true
      return false
    },
    getMembresByStatut: function () {
      let retour = {
        licencied: [],
        notLicencied: [],
        nearNotLicencied: [],
      }
      this.licencesQueried.forEach((item, index) => {
        if (this.isLicencied(item.date_fin))
          retour.licencied.push(item)
        if (this.isNearNotLicencied(item.date_fin))
          retour.nearNotLicencied.push(item)
        if (this.isNotLicencied(item.date_fin))
          retour.notLicencied.push(item)
      })
      return retour;
    },
    moment: function () {
      return moment();
    },
    dateTwoYearsAgo: function () {
      return moment().subtract(2, 'years').format('DD/MM/YYYY')
    },
    dateOneYearAgo: function () {
      return moment().subtract(1, 'years').format('DD/MM/YYYY')
    },
    refreshListing: function () {
      var these = this
      this.loadingRequest = true
      this.licencesQueried = []
      this.$http.post(process.env.API_URL + "getListMember", this.constructForm())
        .then(function (response) {
          these.disabledBtn = false
          these.licencesQueried = response.body;
          these.licencesChecked = [];
          these.setDoublons();
          these.loadingRequest = false
        }, (response) => {
          these.$noty.error("La requête n'a pas pu aboutir")
          these.disabledBtn = false
          these.loadingRequest = false
        })
    },
    exportListing: function () {
      var these = this
      this.loadingRequest = true
      this.$http.post(process.env.API_URL + "getListMemberToXLS", this.constructForm(),{responseType: 'blob'})
        .then(function (response) {
          these.disabledBtn = false
          these.loadingRequest = false
          var blob = new Blob([response.body], {type: "application/vnd.ms-excel"});
          FileSaver.saveAs(blob, "exportListingMembres.xls");
          return response.blob();
        }, (response) => {
          these.$noty.error("La requête n'a pas pu aboutir")
          these.disabledBtn = false
          these.loadingRequest = false
        })
    },
    getProchainPassage(prochainPassage) {
      return getProchainPassage(prochainPassage)
    },
    idGradeIsDanOrFirstKeup(idGrade) {
      return this.getGrades.find((item) => {
        return (item.desc == "noire" || item.desc == "poom" || item.grade == '1er KEUP') && item.id == idGrade
      })
    },
    sendForSave: function (item) {
      let these = this
      this.saveEnCours = true
      return this.$http.post(process.env.API_URL + "setGrade", JSON.stringify({
        "id_membre": item.id_membre,
        "id_club": these.getClub.id,
        "id_grade": item.grade.id,
      })).then(function (response) {
        these.$noty.success("Les modifications ont été enregistrées")
        these.saveEnCours = false
      }, (response) => {
        these.$noty.error("Les modifications n'ont pas pu être enregistrées")
        these.saveEnCours = false
      })
    },
    selectAll: function () {
      this.licencesChecked = [];
      this.licencesChecked = this.licencesQueried.map(function (item) {
        return item.id
      });
    },
    deselectAll: function () {
      this.licencesChecked = [];
    },
    exportCSV: function () {
    },
    setDoublons: function () {
      let result = {}
      this.licencesQueried.forEach(function (item, index, array) {
        result[item.id_membre] = true
      })
      this.nombreDoublons = _.keys(result).length
    },
    constructForm: function () {
      return JSON.stringify({
        "id_club": this.getClub.id,
        "notLicencieCurrentYearOnly": this.show.notLicencieCurrentYearOnly,
        "showDoublons": this.show.showDoublons,
        "annees": this.show.annees,
        "memberLicencies": this.show.memberLicencies,
        "memberNotLicencies": this.show.memberNotLicencies,
      })
    },
    formatDate: function (value, ftmIn, fmtOut) {
      if (value == null) return ''
      fmtOut = (typeof fmtOut == 'undefined') ? 'DD/MM/YYYY HH:mm' : fmtOut
      return moment(value, ftmIn).format(fmtOut)
    },
    anneesDispo: function () {
      let annees = _.sortBy(this.getClub.licences, 'annee');
      annees = annees.map(function (item, index, array) {
        return +item.annee
      })
      // debugger
      if (_.indexOf(annees, +(moment().format('Y'))) < 0)
        annees.push(+(moment().format('Y')))
      return _.uniq(annees)
    },
    currentYear: function () {
      return moment().year();
    },
    getGradesOrdered() {
      let grades = []
      this.getGrades.forEach((item) => {
        if (item.desc == "keup" || item.desc == "null" && item.grade != '1er KEUP')
          grades.push(item)
      })
      return _.sortBy(grades, 'ordre')
    },
    getGradesFromHttp() {
      let these = this
      return this.$http.get(process.env.API_URL + "getListGrades")
        .then(function (response) {
          these.setGrades(response.body);
        }, (response) => {
          these.$noty.error("La requête des grades des membres n'a pas pu aboutir")
        })
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // console.log("change")
      // console.log(vm.getGrades)
      vm.licencesQueried = [];
      if (vm.getGrades == null)
        vm.getGradesFromHttp();
      vm.refreshListing();
    })
  },
  filters: {
    idFormat: function (value) {
      return new Intl.NumberFormat("de-DE").format(value)
    }
  },
  components: {},
  computed: {
    ...mapGetters({
      getMember: 'getMember',
      getClub: 'getClub',
      getRoutes: 'getRoutes',
      getGrades: 'getGrades',
      getCart: 'getCart',
    })
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Club/ListMembers.vue